import { atom } from "recoil";

export const adminAtom = atom({
  key: "AdminAtom",
  default: {},
});